import { Attr, Model } from "spraypaint";

import {
  ApplicationRecord,
  objectDirtyChecker,
} from "shared/services/spraypaint";
import type { AppSection, Nullable } from "shared/types";
import { type LaunchpadWidget } from "shared/types/launchpad";

@Model()
class LaunchpadSettings extends ApplicationRecord {
  static jsonapiType = "launchpad_settings";

  @Attr() after: Nullable<number>;

  @Attr() before: Nullable<number>;

  @Attr({ dirtyChecker: objectDirtyChecker }) chartSettings: Record<
    string,
    any
  >;

  @Attr() collapseSyndicated: boolean;

  @Attr({ persist: false }) createdAt: string;

  @Attr() organisationTeamId: number;

  @Attr() rangeLabel: Nullable<string>;

  @Attr({ persist: false }) updatedAt: string;

  @Attr() userId: number;

  @Attr({ dirtyChecker: objectDirtyChecker }) widgets: Record<
    AppSection,
    LaunchpadWidget[]
  >;
}

export default LaunchpadSettings;
